<template>
    <div class="block__nodata">
        <div class="block__nodata--info">
            <div class="item" v-if="Msg === 1">
                <img src="/static/assets/images/ico-datainfo.svg" alt="icone informação">
                <p>
                    Dados disponíveis somente para investidores<br>
                    que aportaram nessa oportunidade.
                </p>
            </div>
            <div class="item" v-else-if="Msg === 2">
                <img src="/static/assets/images/ico-dataprot.svg" alt="icone proteção">
                <p>
                    Seu cadastro possui uma aprovação pendente<br>
                    Aguarde a confirmação de nosso pessoal para o acesso
                </p>
            </div>
            <div class="item" v-else>
                <img src="/static/assets/images/ico-dataprot.svg" alt="icone proteção">
                <p>
                    Para visualizar todos os<br>
                    dados, complete seu cadastro e aguarde aprovação.
                </p>


                <router-link v-if="this.faltaCompletar" to="/informacoes-adicionais/investidor" class="btn btn-primary">Completar cadastro</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import * as mutationTypes from '@/store/mutation-types.js'
    import ApiClient from '../utils/api-client'

    export default {
          props: {
            Msg: {
                require: true,
                type: Number
            }
        },
        data() {
            return {
                faltaCompletar: true
            }
        },
        created() {

            if(this.$store.state.currentUser != null && this.$store.state.currentUser.investor != null)
                if(this.$store.state.currentUser.investor.Status == "APROVADO" || this.$store.state.currentUser.investor.Status == "NEGADO" || this.$store.state.currentUser.investor.Status == "NEGADO_")
                    this.faltaCompletar = false;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/NoDataProfile.vue